export function AdSlot({ label }: { label: string }) {
  return (
    <div
      className="w-full rounded-xl border border-dashed border-gray-300 bg-gray-50 text-gray-400 text-xs flex items-center justify-center py-6"
      aria-label={`Advertisement placeholder: ${label}`}
    >
      Advertisement · {label}
    </div>
  )
}

const AFFILIATES = [
  { name: 'Total Wine & More', desc: 'Order alcohol online & save with case discounts', cta: 'Shop Total Wine' },
  { name: 'BevMo', desc: 'Wide spirits selection with local delivery', cta: 'Shop BevMo' },
  { name: 'Drizly', desc: 'Same-day alcohol delivery for last-minute needs', cta: 'Shop Drizly' },
]

export function RetailerAffiliateCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {AFFILIATES.map(a => (
        <div key={a.name} className="rounded-xl bg-[#F7EBE8] border border-[#D4AF37]/30 p-4 flex flex-col">
          <div className="font-serif font-semibold text-[#6B1D2F]">{a.name}</div>
          <p className="text-xs text-gray-600 mt-1 flex-1">{a.desc}</p>
          <button
            type="button"
            className="mt-3 text-sm font-semibold text-[#6B1D2F] hover:text-[#D4AF37] transition-colors text-left"
            aria-label={`${a.cta} (affiliate link)`}
          >
            {a.cta} →
          </button>
        </div>
      ))}
    </div>
  )
}

export function PremiumBundleCTA() {
  return (
    <div className="rounded-2xl bg-[#222222] text-white p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div>
        <div className="font-serif text-xl font-bold text-[#D4AF37]">Get the Premium Wedding Planner Bundle</div>
        <p className="text-sm text-gray-300 mt-1 max-w-md">
          Printable bar shopping lists, bartender briefing sheets, and seating-adjacent budget trackers &mdash; all in one download.
        </p>
      </div>
      <button
        type="button"
        className="shrink-0 rounded-lg bg-[#D4AF37] text-[#222222] font-semibold px-5 py-2.5 hover:bg-[#c29d2c] transition-colors"
        aria-label="Download premium wedding planner bundle"
      >
        Get the Bundle
      </button>
    </div>
  )
}
